module.exports = __webpack_public_path__ + "static/media/modal-bg-img.8ed00fe4.png";